
import { ObjectUpdate } from '../../../concepts/objects';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Stopwatch } from './Stopwatch';

class CreateStopwatchToolBehavior extends CreatePhysicalToolBehavior2(Stopwatch, 'plop') {

    protected createSubject(u: ObjectUpdate) {
        const subject = super.createSubject(u);
        subject.minutes = '05';
        subject.seconds = '00';
        return subject;
    }
}

export const stopwatchTool = defineToolWithCommonBehaviors({
    id: 'stopwatchTool',
    label: 'Stopwatch',
    category: 'objects',
    // icon: 'deqo://icons/sln/01-interface-essential/stopwatch',
    // weight: 4000,
    behaviors: [
        CreateStopwatchToolBehavior,
    ]
});
